import React from 'react';

import { Group, Text } from '@mantine/core';
import { WorkoutList } from 'types';

interface WorkoutNameCellProps {
  workout: WorkoutList;
  onPreview: (workout: WorkoutList) => void;
}

const WorkoutNameCell = ({ workout, onPreview }: WorkoutNameCellProps): JSX.Element => (
  <Group spacing='xs' noWrap>
    <Text
      onClick={() => onPreview(workout)}
      weight='bold'
      underline
      sx={{ cursor: 'pointer', width: 'fit-content' }}
    >
      {workout.name}
    </Text>
  </Group>
);

export default WorkoutNameCell;
